import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import LeftContact from './Left-contact';

const ContactContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Contacts' parent='Apps' title='Contacts' />
      <div className='email-wrap bookmark-wrap'>
        <Row>
          <LeftContact />
        </Row>
      </div>
    </Container>
  );
};
export default ContactContainer;
